import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RvHookupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rv_hookup"}/>
}
